import { useEffect } from "react";
const TOP_REVEAL_THRESHOLD = 80;
const DIRECTION_DELTA = 4;

const ChatWidgetController = () => {
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const onScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= TOP_REVEAL_THRESHOLD) {
        document.body.classList.remove("chat-widget-hidden");
      } else if (currentScrollY > lastScrollY + DIRECTION_DELTA) {
        document.body.classList.add("chat-widget-hidden");
      } else if (currentScrollY < lastScrollY - DIRECTION_DELTA) {
        document.body.classList.remove("chat-widget-hidden");
      }

      lastScrollY = currentScrollY;
    };

    document.body.classList.remove("chat-widget-hidden");
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      document.body.classList.remove("chat-widget-hidden");
    };
  }, []);

  return null;
};

export default ChatWidgetController;
